module.exports = __webpack_public_path__ + "media/images/sparkle-fb9711cc2ce75cc099424a68af0af715.svg";